import { useAuth } from '@/contexts/AuthContext';
import { formatCurrency as baseCurrencyFormat, formatDate as baseDateFormat } from '@/lib/utils';

export const useCurrency = () => {
  const { activeOrg } = useAuth();
  
  const currencyCode = activeOrg?.currency || 'INR';
  const timezone = activeOrg?.timezone || 'Asia/Kolkata';
  
  const formatCurrency = (amount) => {
    return baseCurrencyFormat(amount, currencyCode);
  };
  
  const formatDate = (dateString) => {
    return baseDateFormat(dateString, timezone);
  };
  
  return {
    currencyCode,
    timezone,
    formatCurrency,
    formatDate
  };
};
